const EnumSegment = Object.freeze({
  MAX: 100,
  MIDDLE: 50,
  MIN: 10,
});

export default EnumSegment;
